export default __webpack_public_path__ + "linux-logo.png";